// extracted by mini-css-extract-plugin
module.exports =  {"columns":"mhfPGqWB5omw8nolKUrT","row":"kmOkqP6k7ISgRxKY0K4r","cell":"SIofN4LtNmUuixO2mn55","warning":"CdvzSMAAXZfpdfMSs_Xb"};